import { MouseEvent } from "react";

declare global {
  interface Window {
    Optanon?: {
      ToggleInfoDisplay: () => void;
    };
  }
}

export const LOCALHOST_DOMAIN = "http://localhost:3000";

export const isHrefFragment = (href: string) => href.startsWith("#");

const resolveScrollTarget = (href: string): HTMLElement | null => {
  if (!href.startsWith("#")) return null;

  const raw = href.slice(1);
  let id = raw;
  try {
    id = decodeURIComponent(raw);
  } catch {
    // malformed encoding — use the raw string as-is
  }

  const byId = document.getElementById(id);
  if (byId) return byId;

  // Fallback for non-ID fragment selectors (avoid throwing on invalid selectors)
  try {
    const el = document.querySelector(href);
    return el instanceof HTMLElement ? el : null;
  } catch {
    return null;
  }
};

export const handleSpecialLinks = (
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string,
): boolean => {
  if (href === "#cookiepro") {
    e.preventDefault();
    if (window && window.Optanon) {
      window.Optanon.ToggleInfoDisplay();
    }
    return true;
  }
  return false;
};

export const handleClickScroll = (
  e: MouseEvent<HTMLAnchorElement>,
  href: string,
) => {
  e.preventDefault();

  const scrollElement = resolveScrollTarget(href);

  if (!scrollElement) {
    console.warn(`handleClickScroll: no element found for "${href}"`);
    return;
  }

  scrollElement?.scrollIntoView({ behavior: "smooth" });
  scrollElement?.focus();
};
